<template>
  <div id="cancelOfCurrent">
    <div class="Grid85004776">
      <div class="Grid3CFB3B2B">
        <div>
          <md-field-item
            :content="SelectorBoxB14C.content"
            :title="$t('label.label186')"
            :placeholder="$t('label.label187')"
            :arrow="true"
            :solid="true"
            :align="'right'"
            @click="SelectorBoxB14C.value=true"
          >
          </md-field-item>
          <md-picker
            v-model="SelectorBoxB14C.value"
            :title="$t('label.label186')"
            :cancel-text="$t('btn.btn2')"
            :ok-text="$t('btn.btn1')"
            :cols="1"
            :default-index="[0]"
            :is-cascade="true"
            :large-radius="true"
            :ref="'picker1'"
            :data="SelectorBoxB14C.data"
            @confirm="chooseSelectorBoxB14C"
          ></md-picker>
        </div>
      </div>
      <div class="Grid39DAC6A9">
        <md-button :text="'确定'" :type="'primary'" :round="true" @click="getTime">{{$t('btn.btn10')}}</md-button>
      </div>
    </div>
  </div>
</template>
<script>
import { FieldItem, Selector, InputItem, Agree, Button, Picker, Toast, Dialog } from '@gidc/mobile'
import {
  USERACCLIST,
  BILLACCOUNTNO,
  PRODUCTDRAW,
  PRODTERMINATEAGREE,
  DUALAUTHENTICATION,
  BUYTIMESTATE
} from '../../api/smartdeposit'
import { mapGetters } from 'vuex'
export default {
  name: 'cancelOfCurrent',
  components: {
    [FieldItem.name]: FieldItem,
    [Selector.name]: Selector,
    [InputItem.name]: InputItem,
    [Agree.name]: Agree,
    [Picker.name]: Picker,
    [Button.name]: Button
  },
  computed: {
    ...mapGetters([
      'proInfoDetails',
      'RnInfo',
      'headerInfo'
    ])
  },
  watch: {
    headerInfo: function (newval, oldval) {
      console.log("newval.headers['x-business-token']", newval.headers['x-business-token'])
      this.dualAuthenticationSecond(newval.headers['x-business-token'])
    }
  },
  data () {
    return {
      SelectorBoxB14C: {
        content: '',
        value: false,
        data: [[]]
      },
      InputItem56A0: {
        value: ''
      },
      InputItem56A1: {
        value: ''
      },
      accList: [],
      payAcctNo: '',
      accID: '',
      balance: '' // 可以支取的金額
    }
  },
  methods: {
    dualAuthentication () {
      const params = {
        _token_name: this.RnInfo.token
      }
      this.$remote.post(DUALAUTHENTICATION + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          if (res.map.code === '418') {
            window.emitRNFunction('authentication', res.map.data.strategys[0])
          }
        })
    },
    dualAuthenticationSecond (token) {
      const params = {
        _token_name: this.RnInfo.token
      }
      this.$remote.post(DUALAUTHENTICATION + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, xBusinessToken: token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          if (res.status === '200') {
            this.comfirm()
          }
        })
    },
    getTime () {
      this.$remote.post(BUYTIMESTATE + '?_locale=' + this.$exchangeLang(this.RnInfo.language), {}, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          if (res.buyTimeState === 'true') {
            this.dualAuthentication()
          } else {
            Dialog.alert({
              content: this.$t('label.label3'),
              cancelText: this.$t('btn.btn2'),
              confirmText: this.$t('btn.btn1'),
              onConfirm: () => window.emitRNFunction('goToPage')
            })
          }
        })
    },
    comfirm () {
      if (this.proInfoDetails.balance === '0') {
        const params = {
          baseAcctNo: this.proInfoDetails.baseAcctNo,
          ccy: this.proInfoDetails.ccy,
          prodType: 'FP01060005'
        }
        this.$remote.post(PRODTERMINATEAGREE + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
          .then(resp => {
            this.$router.push({ name: 'withdrawResult', params: { status: true } })
          })
      } else {
        const params = {
          serviceCode: 'MBSD_BP_BS', // 服务领域
          messageType: '1000',
          messageCode: '0017', // 服务编码
          baseAcctNo: this.proInfoDetails.baseAcctNo, // 智能存款账号
          ccy: this.proInfoDetails.ccy, // 账户币种
          prodType: 'FP01060005', // 产品类型
          acctSeqNo: '', // 账号子序号
          userAccountId: this.accID,
          tranAmt: this.proInfoDetails.balance, // 支取金额
          withdrawBaseAcctNo: this.payAcctNo, // 赎回入账账号
          remark: '', // 备注
          password: '', // 支取密码
          wtdIntRate: '' // 支取利率
        }
        this.$remote.post(PRODUCTDRAW + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
          .then(res => {
            const params = {
              baseAcctNo: this.proInfoDetails.baseAcctNo,
              ccy: this.proInfoDetails.ccy,
              prodType: 'FP01060005'
            }
            this.$remote.post(PRODTERMINATEAGREE + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
              .then(resp => {
                this.$router.push({ name: 'withdrawResult', params: { status: true } })
              })
          })
          .catch(err => {
            this.$router.push({ name: 'withdrawResult', params: { status: false, msg: err.msg } })
          })
      }
    },
    getAccNo () {
      const resParams = {
        id: this.accID
      }
      this.$remote.post(BILLACCOUNTNO + '?_locale=' + this.$exchangeLang(this.RnInfo.language), resParams, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          this.payAcctNo = res.accountNo
        })
    },
    getAccNoList () {
      const params = {}
      this.$remote.post(USERACCLIST + '?_locale=' + this.$exchangeLang(this.RnInfo.language), params, { headers: { _token_name: this.RnInfo.token, 'x-i18n': this.$exchangeLang(this.RnInfo.language) } })
        .then(res => {
          res.list.forEach(item => {
            item = { text: item.currency + '-' + item.accountCoreNo, value: item.id, currency: item.currency }
            this.SelectorBoxB14C.data[0].push(item)
            this.accList.push(item)
          })
          this.SelectorBoxB14C.data[0] = this.SelectorBoxB14C.data[0].filter(item => item.currency === this.proInfoDetails.ccy)
          console.log('this is SelectorBoxB14C', this.SelectorBoxB14C.data[0])
          if (this.SelectorBoxB14C.data[0].length > 0) {
            this.SelectorBoxB14C.content = this.SelectorBoxB14C.data[0][0].text
            this.payCcy = this.SelectorBoxB14C.data[0][0].currency
            this.accID = this.SelectorBoxB14C.data[0][0].value
            this.getAccNo()
          } else {
            this.SelectorBoxB14C.content = ''
            this.payCcy = ''
            this.accID = ''
            Toast.info('您没有该币种账户')
          }
        })
    },
    chooseSelectorBox6ECF (obj) { this.SelectorBox6ECF.content = obj.text },
    chooseSelectorBox97E8 (obj) { this.SelectorBox97E8.content = obj.text },
    chooseSelectorBoxB14C (obj) { this.SelectorBoxB14C.content = obj[0].text }
  },
  mounted () {
    this.proInfo = this.proInfoDetails
    this.$route.meta.title = this.$getFormat(this.$t('title.title15'), this.proInfoDetails.prodName)
    this.getAccNoList()
  }
}
</script>
<style lang="stylus">
  #cancelOfCurrent{
    .Grid85004776{
      .Grid3CFB3B2B{
        .md-field-item{
          .md-field-item-content{
            min-height .92rem
            height .92rem
            .md-field-item-title{
              font-size .28rem
              font-weight 400
              color #1E1E1E
              line-height .4rem
              text-align left
            }
            .md-field-item-control{
              height .4rem
              font-size .28rem
              font-weight 400
              color #333333
              line-height .4rem
              input{
                height 40px
                font-size 28px
                font-weight 400
                color #333333
                line-height 40px
                text-align right
              }
              input::placeholder {
                      color #999999
                      font-weight 400
                      font-size .28rem
                      height .4rem
                      line-height .4rem
                    }
              .md-field-item-placeholder{
                height .4rem
                font-size .28rem
                font-weight 400
                color #999999
                line-height .4rem
              }
            }
          }
        }
      }
      .Grid3BD34410{
        .md-field-item{
          padding .3rem 0
          .md-field-item-content{
            height .4rem
            min-height .4rem
            width 4rem
            .md-field-item-control{
              padding 0 .3rem
              .md-input-item-input{
                font-weight 400
                color #333333
                font-size .28rem
                height .4rem
                line-height .4rem
              }
              input::placeholder {
                color #999999
                font-weight 400
                font-size .28rem
                height .4rem
                line-height .4rem
              }
            }
          }
          .md-field-item-content::before{
            content none
          }
        }
      }
      .Grid39DAC6A9{
        .md-button{
          height .92rem
          min-height .9rem
          .md-button-inner{
            .md-button-content{
              height .5rem
              font-size .36rem
              font-weight 500
              color #FFFFFF
              line-height .5rem
            }
          }
        }
        .md-button.primary{
          background linear-gradient(135deg, #4792F7 0%, #2B80F4 100%)
          border-radius .46rem
        }
      }
    }
    .md-popup-box{
      .md-popup-title-bar{
        .title-bar-left{
          width auto
        }
        .title-bar-right{
          width auto
        }
      }
    }
  }

</style>
<style lang="stylus" scoped>
  #cancelOfCurrent{
    .Grid85004776{
      .Grid3CFB3B2B{
        padding 0 .3rem
      }
      .Grid3BD34410{
        position relative
        padding .3rem
        .textF0892176{
          font-size .28rem
          display block
          font-weight 400
          height .4rem
          line-height .4rem
          color #1E1E1E
        }
        .GridE89DD886{
          display flex
          justify-content space-between
          .text6D2D4F7E{
            display inline-block
            font-size .28rem
            height .4rem
            font-weight 400
            color #1E1E1E
            line-height .4rem

          }
          .text33DFC870{
            display inline-block
            font-size .28rem
            font-weight 400
            color #3A56D8
            line-height .4rem
          }
        }
      }
      .Grid3BD34410::after{
        position absolute
        bottom 0
        content ''
        width 92%
        height .02rem
        background #ECECEC
      }
      .GridCB5CCE6B{
        font-size .2rem
        font-weight 400
        color #999999
        line-height .28rem
        padding .3rem
      }
      .Grid39DAC6A9{
        padding .6rem .3rem .3rem
      }
    }
  }
</style>
